export default __webpack_public_path__ + "img/92ea60cbd8aaac149d84345d8cf46d88.svg";